import { GoogleOAuthProvider } from "@react-oauth/google"
import { BrowserRouter, Route, Routes } from "react-router-dom"
import MainShell from "./routing/shells/MainShell"
import React, { useState } from "react"
import ScrollToTop from "./components/ScrollToTop"
import { useDispatch } from "react-redux"
import { useEffect } from "react"
import { clearInstallPrompt, setInstallPrompt } from "./redux/prompts.slice"
import showToasts from "./utils/showToasts"
import { useTranslation } from "react-i18next"
import RootShell from "./routing/shells/RootShell"
import PullToRefresh from "./components/PullToRefresh"
import { isInStandaloneMode, isIOS } from "./utils/helpers"
import "./firebase"
import { onMessageListener } from "./firebase"
import { hotjar } from "react-hotjar"
import { Helmet, HelmetProvider } from "react-helmet-async"
import ErrorBoundary from "./components/ErrorBoundary"

const App = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [notification, setNotification] = useState({
    title: "",
    body: "",
    data: undefined,
  })
  const [hotjarIsInitialized, setHotjarIsInitialized] = useState(false)

  useEffect(() => {
    if (process.env.NODE_ENV === "production" && !hotjarIsInitialized) {
      hotjar.initialize(
        process.env.REACT_APP_HOTJAR_ID,
        process.env.REACT_APP_HOTJAR_VERSION
      )
      setHotjarIsInitialized(true)
    }
  }, [hotjarIsInitialized])

  useEffect(() => {
    if (notification?.title) {
      showToasts("notification", notification)
    }
  }, [notification])

  useEffect(() => {
    window.addEventListener("beforeinstallprompt", (event) => {
      event.preventDefault()
      dispatch(setInstallPrompt(event))
    })

    window.addEventListener("appinstalled", () => {
      dispatch(clearInstallPrompt())
      showToasts("regular", t("toasts.app-installed"))
    })
  }, [dispatch])

  onMessageListener()
    .then((payload) => {
      setNotification({
        title: payload?.notification?.title,
        body: payload?.notification?.body,
        data: payload?.data,
      })
    })
    .catch((err) => {
      showToasts("error", t("toasts.notification-error"))
      console.log("Toast error: ", err)
    })

  const routes = (
    <Routes>
      <Route path="valuations/:valuationId/*" element={<MainShell />} />
      <Route path="*" element={<RootShell />} />
    </Routes>
  )

  return (
    <GoogleOAuthProvider
      clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
      redirectUri={process.env.REACT_APP_GOOGLE_REDIRECT_URI}
      scopes={["email", "profile"]}
    >
      <HelmetProvider>
        <Helmet>
          <meta name="description" content={t("meta.description")} />
        </Helmet>

        <BrowserRouter>
          <ErrorBoundary>
            <ScrollToTop />
            {isInStandaloneMode() && isIOS() ? (
              <PullToRefresh>{routes}</PullToRefresh>
            ) : (
              routes
            )}
          </ErrorBoundary>
        </BrowserRouter>
      </HelmetProvider>
    </GoogleOAuthProvider>
  )
}

export default App
